import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailMatchValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const email = group.get('email')?.value;
    const confirmEmail = group.get('confirm_email')?.value;

    if (!email || !confirmEmail) {
      return null; // Don't validate if either field is empty
    }

    return email === confirmEmail ? null : { emailMismatch: true };
  };
}
